import Helper from '@ember/component/helper';
import { service } from '@ember/service';

import { lookupTranslation } from 'umg-ember-backend/utils/intl';

export default class lookupTranslationHelper extends Helper {
  // Services
  @service intl;

  // Hooks
  compute([lookups, append]) {
    return lookupTranslation.call(this, lookups, { append });
  }
}
